module.exports = __webpack_public_path__ + "static/media/evening-icon.c7789f78.png";